import React, { Component } from 'react'
import './../Game/Game.css'
import FlipCard from '../FlipCard/FlipCard'
import { updateObject } from '../../../shared/utitlity'

class Game extends Component {

    constructor(props) {
        super(props)
        this.escFunction = this.escFunction.bind(this);
        this.timer = null;
    }
    state = {
        activeId: null,
        isActive: false,
        completed: false,
        activeIndex: null,
        count: 0,
        paused: false,
        startPausedTime: null,
        totalPausedTime: 0,
        shuffledCards: []
    }

    flipHandler = (id, inIndex) => {
        const cardsList = [...this.state.shuffledCards];
        const index = cardsList.findIndex(card => {
            return card.props.notmatched === true
        })
        if (index > 0) {
            const card = cardsList[index];
            const props = card.props;
            const updatedProps = updateObject(props, { notmatched: false })
            const updatedCard = updateObject(card, { props: updatedProps });
            cardsList[index] = updatedCard;
        }
        if (this.state.isActive) {
            if (this.state.activeId === id) {
                if (this.state.activeIndex === inIndex) {
                    return;
                }
                else {
                    const card = cardsList[inIndex];
                    const activeCard = cardsList[this.state.activeIndex]
                    const props = card.props;
                    const activeProps = activeCard.props
                    const updatedProps = updateObject(props, { active: false, completed: true, notmatched: false })
                    const updatedActiveProps = updateObject(activeProps, { active: false, completed: true, notmatched: false })
                    const updatedCard = updateObject(card, { props: updatedProps });
                    const updatedActiveCard = updateObject(activeCard, { props: updatedActiveProps });
                    cardsList[inIndex] = updatedCard;
                    cardsList[this.state.activeIndex] = updatedActiveCard
                    localStorage.setItem('flip_matched', parseInt(localStorage.getItem('flip_matched')) + 1)
                    this.setState({ shuffledCards: cardsList, isActive: false, activeId: null, activeIndex: null, count: this.state.count + 1 })
                }
            }
            else if (this.state.activeId !== id) {
                const card = cardsList[inIndex];
                const activeCard = cardsList[this.state.activeIndex]
                const props = card.props;
                const activeProps = activeCard.props
                const updatedProps = updateObject(props, { active: false, completed: false, notmatched: true })
                const updatedActiveProps = updateObject(activeProps, { active: false, completed: false, notmatched: false })
                const updatedCard = updateObject(card, { props: updatedProps });
                const updatedActiveCard = updateObject(activeCard, { props: updatedActiveProps });
                cardsList[inIndex] = updatedCard;
                cardsList[this.state.activeIndex] = updatedActiveCard
                localStorage.setItem('flip_wrong', parseInt(localStorage.getItem('flip_wrong')) + 1)
                this.setState({ shuffledCards: cardsList, isActive: false, activeId: null, activeIndex: null })

            }
        }
        else {
            const index = cardsList.findIndex((card) => {
                return card.props.id === id && card.props.index === inIndex
            })
            const card = cardsList[index];
            const props = card.props;
            const updatedProps = updateObject(props, { active: true, completed: false, notmatched: false })
            const updatedCard = updateObject(card, { props: updatedProps });
            cardsList[index] = updatedCard;
            this.setState({ shuffledCards: cardsList, isActive: true, activeId: id, activeIndex: index })
        }
    }
    escFunction(event) {
        if (event.keyCode === 27) {
            localStorage.setItem('flip_abandoned', parseInt(localStorage.getItem('flip_abandoned')) + 1)
            this.props.gameHandler('FLIP')
        }
        else if (event.keyCode === 80) {
            if (this.state.paused) {
                let lapsedTime = new Date() - this.state.startPausedTime;
                this.timer = setTimeout(() => {
                    localStorage.setItem('flip_lost', parseInt(localStorage.getItem('flip_lost')) + 1)
                    this.props.gameHandler('FAIL')
                }, this.props.timer - (new Date() - (lapsedTime + this.state.totalPausedTime) - this.props.startTime))
                this.setState({ paused: false, totalPausedTime: this.state.totalPausedTime + lapsedTime })
            }
            else {
                clearTimeout(this.timer);
                this.setState({ paused: true, startPausedTime: new Date() })
            }

        }
    }
    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, false);
        localStorage.setItem('flipped', true)
        let cardsList = this.props.shuffled.map((value, index) => {
            return <FlipCard
                clicked={this.flipHandler}
                id={"g" + value}//'61440'
                index={index}
                cssClass="g"
                data={String.fromCharCode(61440 + value)}
                key={Math.random()}
                active={false}
                completed={false}
                notmatched={false}
                width={100 / Math.sqrt(2 * this.props.level) + '%'}
                height={100 / Math.sqrt(2 * this.props.level) + '%'}>
            </FlipCard>
        })

        this.setState({ shuffledCards: cardsList })
        this.timer = setTimeout(() => {
            localStorage.setItem('flip_lost', parseInt(localStorage.getItem('flip_lost')) + 1)
            this.props.gameHandler('FAIL')
        }, this.props.timer)
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
        clearTimeout(this.timer);
    }
    render() {
        return <React.Fragment>
            <div className={"game " + this.props.difficulty} id="g">
                <i className="timer"
                    style={{ animation: `${this.props.timer}ms linear 0s 1 normal none ${this.state.paused ? 'paused' : 'running'} timer` }}></i>
                {this.state.shuffledCards}
            </div>
            {this.state.paused ? <div className="pause"></div> : null}
        </React.Fragment>
    }

    componentDidUpdate() {
        if (this.props.level === this.state.count) {
            localStorage.setItem('flip_won', parseInt(localStorage.getItem('flip_won')) + 1)
            const time = (new Date() - this.props.startTime) - this.state.totalPausedTime;
            if (localStorage.getItem('flip_' + this.props.difficulty) === '-:-' |
                localStorage.getItem('flip_' + this.props.difficulty) >= time) {
                localStorage.setItem('flip_' + this.props.difficulty, time)
            }
            this.props.gameHandler('NICE');
        }
    }
}

export default Game;